// src/pages/services/WebPage.jsx

import ServiceLayout from "../../components/ServiceLayout";
import ServiceFeatureCard from "../../components/ServiceFeatureCard";
import img1 from "../../assets/web1.jpg";
import img2 from "../../assets/web2.jpg";
import img3 from "../../assets/web3.jpg";
import img4 from "../../assets/web4.jpg";
import img5 from "../../assets/web5.jpeg";
import img6 from "../../assets/web6.jpg";
import bannerImg from "../../assets/ser1.jpg";
import overviewImg from "../../assets/web.jpg";
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function WebPage() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  const capabilities = [
    {
      title: "Custom Web Applications",
      description: "Tailored web apps aligned with your business processes and customer needs.",
    },
    {
      title: "Responsive UI/UX",
      description: "Intuitive interfaces optimized for all devices.",
    },
    {
      title: "SEO & Performance Optimization",
      description: "Fast-loading, SEO-optimized web apps to boost visibility and user engagement.",
    },
    {
      title: "Maintenance & Security",
      description: "Ongoing support, security updates, and technical maintenance.",
    },
  ];

  const services = [
    {
      title: "E-Commerce Solutions",
      image: img4,
      description: "Create scalable online stores with secure payments, order tracking, and user-friendly interfaces.",
    },
    {
      title: "Content Management Systems",
      image: img1,
      description: "Custom CMS development with WordPress, Strapi, or Headless CMS for seamless content updates.",
    },
    {
      title: "Website Maintenance & Optimization",
      image: img3,
      description: "We ensure your site remains secure, fast, and up-to-date with ongoing performance tuning.",
    },
    {
      title: "Custom Web Development",
      image: img2,
      description: "From concept to deployment, we deliver bespoke web apps tailored to your business logic.",
    },
    {
      title: "Performance Optimization & SEO",
      image: img6,
      description: "Boost speed, search rankings, and accessibility with our full-stack SEO & performance tuning.",
    },
    {
      title: "UI/UX Design Services",
      image: img5,
      description: "Modern, intuitive interfaces with a focus on usability and responsive design principles.",
    },
  ];

  return (
    <ServiceLayout
      title="Web Development"
      bannerImg={bannerImg}
      overviewImg={overviewImg}
      overviewHeading="Build robust, scalable, and user-friendly web solutions that deliver real business value."
      overviewText="Whether you need a custom web app, CMS, or e-commerce platform, our web development team ensures your digital presence is optimized, secure, and scalable."
      capabilities={capabilities}
      buttonText="Get a Custom Web Solution"
      servicesHeading="Our Web Development Services"
    >
      <div className="relative px-4 sm:px-6 pb-16">
        <div className="relative flex items-center">
          <button
            onClick={() => scroll("left")}
            className="hidden sm:block absolute left-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronLeft size={40} />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scroll-smooth px-4 sm:px-12 scrollbar-hide w-full"
            style={{ scrollBehavior: "smooth" }}
          >
            {services.map((service, idx) => (
              <div
                key={idx}
                className="min-w-[300px] max-w-[300px] h-[250px] flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
              >
                <ServiceFeatureCard
                  title={service.title}
                  image={service.image}
                  description={service.description}
                  link="/contact"
                />
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll("right")}
            className="hidden sm:block absolute right-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronRight size={40} />
          </button>
        </div>
      </div>
    </ServiceLayout>
  );
}
